/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{TileAgent as e}from"./TileAgent.js";class t extends e{constructor(){super(...arguments),this.type="elevation",this._scaleRangeEnabled=!1}get _desiredMinLevelDelta(){return this.tile.elevationLevelDelta-(this.tile.elevationLevel-this.tile.level)}get _progressiveLevelModulo(){return 0}}function l(e){return"elevation"===e.type}export{t as ElevationTileAgent,l as isElevationTileAgent};
